import "./AddressList.css";

import { Check, Search, MapPin, Phone,NotepadText } from "lucide-react";
import { useMemo, useState } from "react";

export default function AddressList({
  addresses,
  selectedAddress,
  onConfirm,
}) {
  const [tempId, setTempId] = useState(selectedAddress?.id);

  const [search, setSearch] = useState("");

  const filteredAddresses = useMemo(() => {
    if (!search.trim()) return addresses;

    const keyword = search.toLowerCase();

    return addresses.filter((address) => {
      return (
        address.fname?.toLowerCase().includes(keyword) ||
        address.lname?.toLowerCase().includes(keyword) ||
        address.mobile?.includes(keyword) ||
        address.address?.toLowerCase().includes(keyword) ||
        address.city_name?.toLowerCase().includes(keyword)
      );
    });
  }, [addresses, search]);

  return (
    <div className="address-list-card">
      <div className="address-list-header">
        <h3>
          <NotepadText />
          انتخاب از لیست آدرس‌ها

        </h3>
      </div>

      <div className="address-search">
        <Search size={18} />

        <input
          type="text"
          placeholder="جستجوی آدرس..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="address-items">
        {filteredAddresses.map((address) => {
          const selected = tempId === address.id;

          return (
            <div
              key={address.id}
              className={`address-item

                                    ${selected ? "selected" : ""}

                                `}
              onClick={() => setTempId(address.id)}
            >
              <div className="address-radio">
                {selected && <Check size={14} />}
              </div>

              <div className="address-info">
                <h4>
                  {address.fname} {address.lname}
                </h4>

                <div className="address-mobile">
                  <Phone size={15} />

                  {address.mobile}
                </div>

                <div className="address-location">
                  <MapPin size={15} />
                  {address.province}، {address.city}،{" "}
                  {address.address}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="confirm-address-btn"
        disabled={!tempId}
        onClick={() => {
          const address = addresses.find((a) => a.id === tempId);

          if (address) {
            onConfirm(address);
          }
        }}
      >
        <Check />
        تایید و انتخاب این آدرس
      </button>
    </div>
  );
}
